/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import $ from 'jquery';

/**
 * Element which can:
 * - show and fade in from opacity 0 (completely transparent) to opacity 0.7
 * - and fade out to opacity 0 and hide
 *
 * Its good use is a glasspane over some big element which we need to disable
 * but other use cases are also possible.
 *
 * To use it as a glasspane, position it over covered elements (e.g. with absolute positioning),
 * so that it was a sibling of covered elements, set opacity:0 , z-index bigger then covered elements.
 *
 * Example:
 * <div id=container style="position: relative">
 *   <div id=covered style="z-index:1"></div>
 *   <div id=glasspane style="position: absolute; top:0; left: 0; right: 0; bottom: 0; z-index:2; display: none"></div>
 * </div>
 */
export default class FadingElement {
    constructor(private readonly selector: string, private readonly targetOpacity = 0.7) {}

    public toggle(isVisible: boolean) {
        const jqElement = $(this.selector);
        if (isVisible) {
            if (!jqElement.is(':hidden')) {
                jqElement.animate(
                    {
                        opacity: 0.0,
                    },
                    'slow',
                    'swing',
                    function() {
                        jqElement.hide();
                    },
                );
                jqElement.css('z-index', '-100');
            }
        } else {
            if (jqElement.is(':hidden')) {
                jqElement.css('z-index', '2');
                jqElement.show().animate(
                    {
                        opacity: this.targetOpacity,
                    },
                    'slow',
                );
            }
        }
    }
}
